(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSubformTabular', fbSubformTabularDirective);

    function fbSubformTabularDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/tabular',
            controller: fbSubformTabularDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformTabularDirectiveCtrl($scope, lodash, $timeout, FormBuilderService, FormBuilderHelper) {
        var vm = this,
            elemCount,
            fbService = null
        ;

        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(vm.formIdentifier);
            var elementIdentifier = $scope.$parent.vm.elementIdentifier;
            vm.currentElementIdentifier = elementIdentifier;

            vm.addToModel = addToModel;
            vm.deleteFromModel = deleteFromModel;
            vm.show = show;
            vm.hasRows = hasRows;
            vm.getElementSize = getElementSize;
            vm.hasMaxItems = hasMaxItems;
            vm.hasMinItems = hasMinItems;
            vm.setDefault = setDefault;
            vm.hasDefaultOption = hasDefaultOption;
            vm.hasSortableOption = hasSortableOption;
            vm.hasError = hasError;
            vm.canDelete = canDelete;
            vm.canAdd = canAdd;
            vm.generateChildIdentifier = generateChildIdentifier;
            vm.canSort = false;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;

            vm.view_only = lodash.get(fbService, 'fbData.settings.view_only', false);

            init();
        }

        function init() {
            if (typeof vm.model == typeof undefined) {
                vm.model = [];
            }

            if (lodash.has(vm.fbElement, 'subfields.options.min_items')
                && !!vm.fbElement.subfields.options.min_items) {
                while (vm.model.length < vm.fbElement.subfields.options.min_items) {
                    vm.model.push({});
                }
            }

            if (vm.model.length > 0) {
                for (var i = vm.model.length; i--;) {
                    vm.renderedElements.push({});
                }
            }
            setFirstAsDefault();

            var filtered = lodash.filter(vm.fbElement.subfields.elements, function (o) {
                return o.type != 'hidden';
            });
            elemCount = filtered.length;
            initSortableOptions();
        }

        function setFirstAsDefault() {
            if (lodash.get(vm.fbElement.subfields.options, 'select_first_as_default', true) === true) {

                if (vm.model.length > 0) {
                    // check first if got default===true also
                    const defaultRow = lodash.find(vm.model, {default:true});
                    if (!defaultRow) {
                        vm.model[0].default = true;
                    }
                }
            }
        }

        function mobileAndTabletcheck() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substring(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if (!check) {
                check = (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);
            }
            return check;
        };

        function initSortableOptions() {
            reorderRowIndex();
            var sortableOptions = {
                handler: '.sortable-handler, .sortable-handler .fa',
                filter: '.sub-form-row.tabular',
                ignore: 'input,textarea'
            };
            vm.canSort = lodash.has(vm.fbElement, 'subfields.options.sortable') && !mobileAndTabletcheck();

            if (vm.canSort) {
                angular.merge(sortableOptions, {
                    change: (e) => {
                        if (e) {
                            var itemMoved = vm.model[e.oldIndex];
                            vm.model.splice(e.oldIndex, 1);
                            vm.model.splice(e.newIndex, 0, itemMoved);
                            $scope.$apply();
                        }
                        reorderRowIndex();
                    },
                    placeholder: function (element) {
                        const elementClone = element.clone();
                        elementClone.addClass('sortable-placeholder');
                        elementClone.find('.tabular-content').html('<div>Drop Here</div>');
                        return elementClone;
                    },
                    hint: function (element) {
                        return element.clone().addClass('sortable-hint');
                    }
                });
                vm.sortableOptions = sortableOptions;
            } else {
                vm.sortableOptions = false;
            }
        }

        function addToModel() {
            vm.model.push({});
            vm.renderedElements.push({});
            reorderRowIndex();
            if (vm.model.length === 1) {
                setFirstAsDefault();
            }
        }

        function deleteFromModel(item) {
            var index = vm.model.indexOf(item);
            vm.model.splice(index, 1);
            vm.renderedElements.splice(index, 1);
            reorderRowIndex();
        }

        function show(elemObj) {
            return !(elemObj.type == 'hidden');
        }

        function hasRows() {
            return vm.model.length > 0;
        }

        function getElementSize(element) {
            if (lodash.has(element, 'attr.size')) {
                return "small-" + element.attr.size;
            }
            return "small-" + (12 / elemCount);
        }

        function hasMaxItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.max_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.max_items > vm.model.length);
        }

        function hasMinItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.min_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.min_items < vm.model.length);
        }

        function hasDefaultOption() {
            return lodash.get(vm.fbElement, 'subfields.options.select_default', false);
        }

        function hasSortableOption() {
            return lodash.get(vm.fbElement, 'subfields.options.sortable', false);
        }

        function setDefault($event, row) {
            $event.preventDefault();
            defaultFunc(row);
        }


        function reorderRowIndex() {
            if (hasSortableOption()) {
                $timeout(function () {
                    angular.forEach(vm.model, (row, index) => {
                        row.order = index;
                    });
                });
            }
        }

        function defaultFunc(row) {
            const result = vm.model.map((_row) => {
                return {
                    default: (_row.$$hashKey == row.$$hashKey)
                };
            });
            angular.merge(vm.model, result);
        }

        function hasError(index) {
            return fbService.elementsService.getValidationRule(vm.currentElementIdentifier + '.' + index);
        }

        function canDelete() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_delete', true);
        }

        function canAdd() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_add', true);
        }

        function generateChildIdentifier(index, element_name) {
            return vm.currentElementIdentifier + '[' + index + '].' + element_name;
        }

        // hsa default
    }
})();
